export default __webpack_public_path__ + "static/media/single_web-lg@2x.10c9f3c8.jpg";